/**
 * ESG Score model representing Environment, Social, and Governance scores
 * Each score is a number from 0-100
 */
export interface ESGScore {
  environment: number;
  social: number;
  governance: number;
}

/**
 * Calculate the overall ESG score as the average of E, S, and G
 */
export function calculateOverallScore(score: ESGScore): number {
  return Math.round((score.environment + score.social + score.governance) / 3);
}

/**
 * ESG category colors following the design spec
 */
export const ESG_COLORS = {
  environment: '#2e7d32',
  social: '#1976d2',
  governance: '#7b1fa2'
} as const;

/**
 * ESG chip background colors (lighter variants)
 */
export const ESG_CHIP_BACKGROUNDS = {
  environment: '#e8f5e9',
  social: '#e3f2fd',
  governance: '#f3e5f5'
} as const;
